import React from "react";

const RoleFormSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex flex-row items-center justify-between gap-4 mb-4 px-2">
        <div className="flex items-center gap-2">
          <div className="h-5 w-5 rounded bg-gray-200 animate-pulse"></div>
          <div className="h-5 w-32 rounded bg-gray-200 animate-pulse"></div>
        </div>
      </div>

      {/* Name and Description Fields */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <div>
          <div className="h-4 w-20 rounded bg-gray-200 animate-pulse mb-2"></div>
          <div className="h-10 w-full rounded bg-gray-200 animate-pulse"></div>
        </div>
        <div>
          <div className="h-4 w-32 rounded bg-gray-200 animate-pulse mb-2"></div>
          <div className="h-10 w-full rounded bg-gray-200 animate-pulse"></div>
        </div>
      </div>

      {/* Main Content - Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {/* Left Column - Modules */}
        <div className="border rounded-lg p-4">
          <div className="flex justify-between items-center gap-2 mb-2">
            <div className="h-5 w-20 rounded bg-gray-200 animate-pulse"></div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-16 rounded bg-gray-200 animate-pulse"></div>
              <div className="h-4 w-4 rounded bg-gray-200 animate-pulse"></div>
            </div>
          </div>
          <div className="space-y-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="border rounded-lg">
                <div className="p-4 border-b flex items-center justify-between">
                  <div className="h-5 w-24 rounded bg-gray-200 animate-pulse"></div>
                  <div className="h-4 w-4 rounded bg-gray-200 animate-pulse"></div>
                </div>
                <div className="p-4">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-2 px-8">
                    {[1, 2, 3].map((j) => (
                      <div key={j} className="flex items-center gap-2">
                        <div className="h-4 w-4 rounded bg-gray-200 animate-pulse"></div>
                        <div className="h-4 w-24 rounded bg-gray-200 animate-pulse"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column - Accounts & Applications */}
        <div className="border rounded-lg p-4">
          <div className="flex justify-between items-center gap-2 mb-2">
            <div className="h-5 w-20 rounded bg-gray-200 animate-pulse"></div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-16 rounded bg-gray-200 animate-pulse"></div>
              <div className="h-4 w-4 rounded bg-gray-200 animate-pulse"></div>
            </div>
          </div>
          <div className="space-y-4">
            {[1, 2].map((i) => (
              <div key={i} className="border rounded-lg">
                <div className="p-4 border-b flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-md bg-gray-200 animate-pulse"></div>
                    <div>
                      <div className="h-4 w-32 rounded bg-gray-200 animate-pulse mb-1"></div>
                      <div className="h-3 w-24 rounded bg-gray-200 animate-pulse"></div>
                    </div>
                  </div>
                  <div className="h-4 w-4 rounded bg-gray-200 animate-pulse"></div>
                </div>
                <div className="p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {[1, 2].map((j) => (
                      <div
                        key={j}
                        className="flex items-center gap-2 px-8 py-2"
                      >
                        <div className="h-4 w-4 rounded bg-gray-200 animate-pulse"></div>
                        <div className="h-8 w-8 rounded-lg bg-gray-200 animate-pulse"></div>
                        <div>
                          <div className="h-4 w-24 rounded bg-gray-200 animate-pulse mb-1"></div>
                          <div className="h-3 w-16 rounded bg-gray-200 animate-pulse"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end gap-3">
        <div className="h-10 w-24 rounded bg-gray-200 animate-pulse"></div>
        <div className="h-10 w-24 rounded bg-gray-200 animate-pulse"></div>
      </div>
    </div>
  );
};

export default RoleFormSkeleton;
